import styled from '@emotion/styled';
import { IconButton, Tooltip } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import InfoIcon from '@material-ui/icons/Info';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from '../UI';
import images from '../UI/images';
import EditIcon from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';

export default function Property({ data, currency }) {
	const classes = useStyles();
	const history = useHistory();

	function handleClick(propertyId, digitalId) {
		if (digitalId > 99) {
			history.push(`/my-portfolio/${propertyId}/process-setting`);
		} else {
			history.push(`/my-portfolio/${propertyId}`);
		}
	}



	let totals = {
		GLA: 0,
		parking: 0,
		GRI: 0,
		wault: 7.7,
		vacancy: 0,
		valuation: 0,
	};
	data.properties.forEach(property => {
		const { valuation, GRI } = property.analysis.details;
		let valuationCurrency, valuationGri;
		if (currency === 'USD') {
			valuationCurrency = valuation.eur * 1.1;
			valuationGri = GRI.eur * 1.1;
		} else if (currency === 'GBP') {
			valuationCurrency = valuation.eur / 1.2;
			valuationGri = GRI.eur / 1.2;
		} else {
			valuationCurrency = valuation.eur;
			valuationGri = GRI.eur;
		};
		return (totals = {
			GLA: totals.GLA + property.analysis.details.GLA,
			parking: totals.parking + property.analysis.details.parking,
			GRI: totals.GRI + valuationGri,
			wault: 7.7,
			vacancy: totals.vacancy + property.analysis.details.vacancy,
			valuation: totals.valuation + valuationCurrency,
		});
	});

	return (
		<Box mb={2}>
			<TableContainer component={Paper}>
				<Table className={classes.table} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell />
							<TableCell align="left">
								<strong>AFP</strong>
							</TableCell>
							<TableCell align="left">
								<Box width="100px">
									<strong>Digital ID</strong>
								</Box>
							</TableCell>
							<TableCell align="left">
								<Box width="100px">
									<strong>Axcess Status</strong>
								</Box>
							</TableCell>
							<TableCell align="left">
								<strong>Country</strong>
							</TableCell>
							<TableCell align="left">
								<strong>City</strong>
							</TableCell>
							<TableCell align="left">
								<strong>Address</strong>
							</TableCell>
							<TableCell align="left">
								<Box width="100px">
									<strong>Asset Type</strong>
								</Box>
							</TableCell>
							<TableCell align="left">
								<strong>Category</strong>
							</TableCell>
							<TableCell align="left">
								<Box width="100px">
									<strong>Sub-Clas</strong>
								</Box>
							</TableCell>
							<TableCell align="left">
								<Box width="100px">
									<strong>GLA</strong>
									<Tooltip title="Gross Lettable Area" aria-label="info">
										<IconButton color="inherit" aria-label="menu">
											<InfoIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</Tooltip>
								</Box>
							</TableCell>
							<TableCell align="left">
								<strong>Parking</strong>
							</TableCell>
							<TableCell align="left">
								<strong>GRI</strong>
								<Tooltip title="Gross Rental Income" aria-label="info">
									<IconButton color="inherit" aria-label="menu">
										<InfoIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
							<TableCell align="left">
								<Box width="100px">
									<strong>WAULT</strong>
									<Tooltip title="Weighted Average Uninterrupted Lease Term" aria-label="info">
										<IconButton color="inherit" aria-label="menu">
											<InfoIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</Tooltip>
								</Box>
							</TableCell>
							<TableCell align="left">
								<strong>Vacancy</strong>
							</TableCell>
							<TableCell align="left">
								<strong>Valuation</strong>
							</TableCell>
							<TableCell align="left">
								<Box width="80px">
									<strong>GY</strong>
									<Tooltip title="Gross Yield with respect to Valuation" aria-label="info">
										<IconButton color="inherit" aria-label="menu">
											<InfoIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</Tooltip>
								</Box>
							</TableCell>
							<TableCell />
						</TableRow>
					</TableHead>
					<TableBody>
						{data.properties.map(property => {
							const {
								afp,
								digitalId,
								country,
								city,
								address,
								assetType,
								category,
								subClass,
								status,
							} = property.sell;
							const { GLA, parking, GRI, wault, vacancy, valuation, GY } = property.analysis.details;
							let valuationCurrency, valuationGri;
							if (currency === 'USD') {
								valuationCurrency = `$${(valuation.eur * 1.1).toLocaleString()}`;
								valuationGri = `$${(GRI.eur * 1.1).toLocaleString()}`;
							} else if (currency === 'GBP') {
								valuationCurrency = `£${(valuation.eur / 1.2).toLocaleString()}`;
								valuationGri = `£${(GRI.eur / 1.2).toLocaleString()}`;
							} else {
								valuationCurrency = `€${(valuation.eur).toLocaleString()}`;
								valuationGri = `€${(GRI.eur).toLocaleString()}`;
							};
							return (
								<TableRow
									key={property.id}
									className={classes.link}
								>
									<TableCell>
										<div
											style={{
												width: '100px',
												height: '100px',
												backgroundImage: `url(${images[property.index][0]})`,
												backgroundRepeat: 'no-repeat',
												backgroundPosition: 'center',
												backgroundSize: 'cover',
											}}
										>
										</div>
									</TableCell>
									<TableCell align="right">{afp}</TableCell>
									<TableCell align="center">
										<ProgressBar digitalId={digitalId}>
											<div />
										</ProgressBar>
									</TableCell>
									<TableCell align="right">
										<Status status={status} onClick={() => handleClick(property.id, digitalId)}>
											<strong>{status}</strong>
										</Status>
									</TableCell>
									<TableCell align="right">{country}</TableCell>
									<TableCell align="right">{city}</TableCell>
									<TableCell align="right" style={{ minWidth: '200px' }}>
										{address}
									</TableCell>
									<TableCell align="right">{assetType}</TableCell>
									<TableCell align="right">{category}</TableCell>
									<TableCell align="right">{subClass}</TableCell>
									<TableCell align="right">{GLA.toLocaleString()} sqm</TableCell>
									<TableCell align="right">{parking}</TableCell>
									<TableCell align="right">{valuationGri}</TableCell>
									<TableCell align="right">{wault} y</TableCell>
									<TableCell align="right">{vacancy.toFixed(2)}%</TableCell>
									<TableCell align="right">{valuationCurrency}</TableCell>
									<TableCell align="right">{GY}%</TableCell>
									<TableCell>
										<Tooltip title="Edit" aria-label="support">
											<IconButton color="primary" aria-label="menu" component={Link} to={`/my-portfolio/${property.id}`}>
												<EditIcon />
											</IconButton>
										</Tooltip>
									</TableCell>
								</TableRow>
							);
						})}
						<TableRow style={{ background: '#eee' }}>
							<TableCell colSpan={9} style={{ background: '#fff' }} />
							<TableCell>
								<strong>Total</strong>
							</TableCell>
							<TableCell align="right">
								<strong>{totals.GLA.toLocaleString()} sqm</strong>
							</TableCell>
							<TableCell align="right">
								<strong>{totals.parking}</strong>
							</TableCell>
							<TableCell align="right">
								<strong>
									{currency === 'EUR' && `€${totals.GRI.toLocaleString()}`}
									{currency === 'GBP' && `£${totals.GRI.toLocaleString()}`}
									{currency === 'USD' && `$${totals.GRI.toLocaleString()}`}
								</strong>
							</TableCell>
							<TableCell align="right">
								<strong>{totals.wault} y</strong>
							</TableCell>
							<TableCell align="right">
								<strong>{totals.vacancy}%</strong>
							</TableCell>
							<TableCell align="right">
								<strong>
									{currency === 'EUR' && `€${totals.valuation.toLocaleString()}`}
									{currency === 'GBP' && `£${totals.valuation.toLocaleString()}`}
									{currency === 'USD' && `$${totals.valuation.toLocaleString()}`}
								</strong>
							</TableCell>
							<TableCell align="right">
								<strong>{((totals.GRI / totals.valuation) * 100).toFixed(2)}%</strong>
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
}

const useStyles = makeStyles({
	table: {
		width: '100%',
	},
	link: {
		'&:hover': {
			background: '#eee',
		},
	},
});

const ProgressBar = styled.div`
	width: 60px;
	height: 8px;
	border-radius: 10px;
	overflow: hidden;
	background: #c1c1c1;
	& > div {
		height: 100%;
		${({ digitalId }) => `width: ${digitalId}%`}
	}
	& > div {
		${({ digitalId }) => {
		if (digitalId < 50) {
			return `
					background: #f44336;
				`;
		} else if (digitalId >= 50 && digitalId < 80) {
			return `
					background: #ff9800;
				`;
		} else {
			return `
					background: #4caf50;
				`;
		}
	}}
	}
`;

const Status = styled.div`
	padding: 0.5rem 1rem;
	background: ${({ status }) => (status === 'Auction' ? '#77aa79' : '#b60037')};
	border-radius: 50px;
	text-align: center;
	color: white;
	cursor: pointer;
`;
